import { isNullish } from "@tinyurldev/tu-ui-vue";

import { logError } from "@Helpers/logger";
import usePaddle from "@Composables/usePaddle";
import BILLING_TYPE from "@Constants/billing-type";
import { getSubscriptionCheckoutSessionApi } from "@Resources/js/api/subscription";
import PADDLE_TRANSACTION_TYPE from "@Constants/paddle-transaction-type";

export default function ({ next, store, nextMiddleware, to }) {
  const { openPaddleCheckout } = usePaddle();
  const subscription = to.query.subscription;
  const interval = to.query.interval;
  const hasSubscription = !isNullish(subscription) && !isNullish(interval);

  if (!store.getters.isUserLoggedIn || !hasSubscription) {
    return next({ name: "homepage" });
  }

  if (store.getters.isUserSubscribed) {
    return next({ name: "settings.subscription" });
  }

  const payload = {
    subscription,
    interval,
    billing_type: BILLING_TYPE.PADDLE,
    currency: store.getters.currency ?? "USD",
    type: "user",
  };

  getSubscriptionCheckoutSessionApi(payload)
    .then((sessionResult) => {
      openPaddleCheckout(PADDLE_TRANSACTION_TYPE.SUBSCRIPTION_PURCHASE, sessionResult);
    })
    .catch((error) => {
      logError("Impossible to subscribe user to paddle!");
      console.log(error);
    });

  return nextMiddleware();
}